import { render } from "./KashtabroShort.vue?vue&type=template&id=3df0c320"
import script from "./KashtabroShort.vue?vue&type=script&lang=js"
export * from "./KashtabroShort.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/localhost/storage/app/public/arair-kiosk-site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__